import { Alert } from 'antd'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'

import { HistoryTimeline } from '@/Ship/Components/History'

import { buildCrmHistoryEntries } from './crmHistoryEntries'
import { CrmHistoryTabStore } from './CrmHistoryTabStore'

import type { CrmHistoryEventMap, CrmHistoryItem } from './CrmHistoryEvent'
import type { HistoryEntry } from '@/Ship/Components/History'

export interface CrmHistoryTabProps {
    /** Колекція власника: `/services/clients`, `/services/carriers` */
    restUrl: string
    uuid: string
    /** Мапа подій власника (`CLIENT_HISTORY_EVENT_MAP`) */
    events: CrmHistoryEventMap
    /** Підписи категорій файлів власника (перевізник, `SPEC-010` §12) */
    fileCategories?: Readonly<Record<string, string>>
    /**
     * Власний будівник рядків — для власника з іншим `payload` подій (заявка,
     * `SPEC-021` §4.7); без нього — загальний будівник CRM
     */
    buildEntries?: (items: readonly CrmHistoryItem[], events: CrmHistoryEventMap) => HistoryEntry[]
}

/**
 * Вкладка «Історія змін» картки клієнта чи перевізника (ADR 041,
 * `SPEC-008` §5.5): хто, коли, що було й що стало. Остання вкладка картки,
 * видно всім, хто читає запис.
 *
 * Стрічку тягнемо на кожне відкриття вкладки — шаблон перемонтовує її
 * ключем-«епохою»: antd тримає вкладку змонтованою, і без цього щойно
 * збережена зміна лишилася б невидимою.
 */
export const CrmHistoryTab = observer(({ restUrl, uuid, events, fileCategories, buildEntries }: CrmHistoryTabProps) => {
    const [store] = useState(() => new CrmHistoryTabStore())

    useEffect(() => {
        void store.load(restUrl, uuid)
    }, [store, restUrl, uuid])

    if (store.failed) {
        return <Alert type="error" showIcon title="Не вдалося завантажити історію змін." />
    }

    const hidden = store.total - store.items.length

    return (
        <HistoryTimeline
            entries={
                buildEntries ? buildEntries(store.items, events) : buildCrmHistoryEntries(store.items, events, fileCategories)
            }
            loading={store.isLoading}
            {...(hidden > 0 ? { note: `Показано останні ${store.items.length} подій із ${store.total}` } : {})}
        />
    )
})
